// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class DistributionOverview {
    /**
    * Number of photos for this distribution
    */
    'photos_count': number;
    /**
    * Whether the distribution has been normalized
    */
    'is_normalized': boolean;
    /**
    * Count of unique addresses with automatic airdrops
    */
    'automatic_airdrops_addresses': number;
    /**
    * Total count of automatic airdrops
    */
    'automatic_airdrops_count': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "photos_count",
            "baseName": "photos_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "is_normalized",
            "baseName": "is_normalized",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "automatic_airdrops_addresses",
            "baseName": "automatic_airdrops_addresses",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "automatic_airdrops_count",
            "baseName": "automatic_airdrops_count",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return DistributionOverview.attributeTypeMap;
    }

    public constructor() {
    }
}
